// src/components/layout/AppLayout.tsx
import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header'; // si tienes Header
import * as S from './Sidebar.styles'; // estilos compartidos
import { DevBadge } from './AppLayout.styles';
import { isDevEnvironment } from "../../helpers/appVersion";

const AppLayout: React.FC = () => {
  const [isSidebarOpen, setSidebarOpen] = useState(false);
  const toggleSidebar = () => setSidebarOpen(!isSidebarOpen);

  return (
    <S.LayoutContainer isSidebarOpen={isSidebarOpen}>
      <Sidebar isSidebarOpen={isSidebarOpen} />
      <div className="main-content">
        <S.ContentContainer>
          <Header isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
          <Outlet />
        </S.ContentContainer>
      </div>
      {isDevEnvironment() && <DevBadge>Dev</DevBadge>}
    </S.LayoutContainer>
  );
};

export default AppLayout;
